export type VideoKey = 'overview' | 'series' | 'fields' | 'community' | 'podcasting' | 'journal' | 'chat' | 'stories'
export type ExplainerVideoEntry = {id: string | null; title: string; seconds: number; poster: string}

/** Explainer videos (src/gnothi/videos), one per surface. `id` is the YouTube id, null until the upload exists; every slot renders nothing (or its fallback) while it is null. `poster` is self-hosted (web/public/videos, `npm run poster` in src/gnothi/videos) so no request reaches Google before a play press. Literals only: the prerendered splash pages import this. */
export const EXPLAINER_VIDEOS: Record<VideoKey, ExplainerVideoEntry> = {
  overview: {id: 'SKGZkLWpy64', title: 'Gnothi overview', seconds: 122, poster: '/videos/overview.jpg'},
  series: {id: '6Q3yRYj_tsE', title: 'Series', seconds: 110, poster: '/videos/series.jpg'},
  fields: {id: 'ixFHLOCFec0', title: 'Fields', seconds: 154, poster: '/videos/fields.jpg'},
  community: {id: 'LkA9fAZ_-gs', title: 'Community', seconds: 114, poster: '/videos/community.jpg'},
  podcasting: {id: 'hDHtJwsjreI', title: 'Publishing a podcast', seconds: 117, poster: '/videos/podcasting.jpg'},
  journal: {id: 'ilwJAFqnHRI', title: 'Journal', seconds: 90, poster: '/videos/journal.jpg'},
  chat: {id: 'JJkiUyoXm1c', title: 'Chat', seconds: 77, poster: '/videos/chat.jpg'},
  stories: {id: 'yWjxgG01yVM', title: 'Learning through story', seconds: 97, poster: '/videos/stories.jpg'},
}

/** m:ss, for the duration chip and the "How it works (m:ss)" label. */
export const videoLength = (seconds: number) => {
  const s = Math.round(seconds)
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
}

export const youtubeWatchUrl = (id: string) => `https://www.youtube.com/watch?v=${id}`
